

<div class="text-center notification pt-16 pb-16">
  <h4 class="m-0 text-white" style="margin: 0 60px !important;"><b>Notifications</b></h4>
</div>

<mat-nav-list class="notification-list" role="list"  *ngFor="let n of notifications | slice:0:10">
  <!-- Notification item -->
  <mat-list-item class="notific-item" role="listitem" routerLinkActive="open" (click)="changeStatus(n)">
    <mat-icon [color]="n.color" class="notific-icon mr-16">question_answer</mat-icon>
    <a>
      <div class="mat-list-text">
        <h4 class="message">{{n?.title}}</h4>
        <small class="time text-muted">{{changeTime(n?.created_on)}}</small>
      </div>
    </a>
  </mat-list-item>
</mat-nav-list>
<div class="text-center view-more mt-16" *ngIf="notifications?.length">
  <a href="#" [routerLink]="['/notification-list']">View More</a>
</div>
<div class="text-center view-more mt-16" *ngIf="notifications?.length<1">
  <p >No notification found.....</p>
</div>

<!-- [routerLink]="['notification-list']" -->